import { render, staticRenderFns } from "./ApplicationUserCustomDashboardList.vue?vue&type=template&id=15102b3b"
import script from "./ApplicationUserCustomDashboardList.vue?vue&type=script&lang=js"
export * from "./ApplicationUserCustomDashboardList.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUserCustomDashboardList.vue?vue&type=style&index=0&id=15102b3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports